var _learnq = _learnq || [];

var ProductForm = function(template, product, formSelector, submitCb) {
  var pushIfNotFound = function(el, list) {
    if (!list.includes(el)) {
      list.push(el);
    }
  };
  this.sanitizeSelectorComponent = function(str) {
    return str.toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/[\.\s]/g, '-');
  };
  this.isAbbreviatedForm = function() {
    return $('.collection-content-container').length > 0;
  };

  this.closePopup = (function() {
    $('#preorder-popup').removeClass('preorder-popup-active');
    $('#preorder-popup').html('');
    this.SUBMIT_CB && this.SUBMIT_CB();
  }).bind(this);

  this.sel = (function(selector) {
    return $(this.FORM_SELECTOR + (selector ? (' ' + selector) : ''));
  }).bind(this);

  this.logLearnq = (function() {
    try {
      _learnq = window._learnq || [];
      var item = {
        Name: this.PRODUCT.title,
        ProductID: this.PRODUCT.id,
        Categories: this.PRODUCT.learnq.categories,
        ImageURL: this.PRODUCT.learnq.image_url,
        URL: this.PRODUCT.learnq.url,
        Brand: this.PRODUCT.vendor,
        Price: this.PRODUCT.learnq.price,
        CompareAtPrice: this.PRODUCT.learnq.compare_at_price
      };
      _learnq.push(['track', 'Added to Cart', item]);
    } catch (e) { }
  }).bind(this);

  this.buildModel = (function(product) {
    var valueLabelMap = {
      'liner': 'With Liner',
      'no-liner': 'Without Liner',
      'small': 'S',
      'medium': 'M',
      'large': 'L',
      'short-5': 'Short 5&quot;',
      'short-6': 'Short 6&quot;',
      'classic-7': 'Regular 7&quot;',
      'long-9': 'Long 9&quot;',
      'long-9-14': 'Long 9&quot;', 
      'xxxl': '3XL'
    };
    var accessibilityLabelMap = {
      'liner': 'With Liner',
      'no-liner': 'Without Liner',
      'small': 'Small',
      'medium': 'Medium',
      'large': 'Large',
      'short-5': 'Short 5 inches',
      'short-6': 'Short 6 inches',
      'classic-7': 'Regular 7 inches;',
      'long-9': 'Long 9 inches',
      'long-9-14': 'Long 9 inches',
      'xl': 'Extra Large',
      'xxl': 'Double Extra Large',
      '3xl': 'Triple Extra Large',
      'xxxl': 'Triple Extra Large'
    };
    var swatchMap = {
      'length (inseam)': 'Length'
    };
    var valueDescriptionMap = {
      'regular': 'Fits 32"-34" inseam',
      'short': 'Fits 28"-30" inseam'
      // 'no-liner': '$1 liner removal fee'
    };
    var collectionHandleMap = {
      'business': 'Business Pants',
      'original': 'Original',
      'khaki': 'Khaki',
      'bathing-suit': 'Bathing Suit',
      'golf-shorts': 'Golf Shorts',
      'business-pants': 'Pants',
      'khaki-pants': 'Stretch Khakis',
      'stretch-khakis': 'Stretch Khakis',
      'joggers': 'Joggers',
      'sweatpants': 'Classic Cotton Sweats',
      'rare-birddogs': 'Rare Birddogs'
    };
    product = $.extend({
      collection_handle: '',
      collections: []
    }, product);
    product.raw_price = product.price;
    product.price = '$' + (product.price / 100);
    var productCollection = collectionHandleMap[product.collection_handle] ?
      collectionHandleMap[product.collection_handle] : product.collection_handle;
    product.has_fit_guide = !['boxer-briefs', 'the-merch', 'polos'].includes(productCollection) && product.handle !== 'gift-card';
    
    if (product.related_products) {
      if (!product.tags.includes('preorder') && product.preorder_product &&
          !this.isAbbreviatedForm()) {
        this.PREORDER_PRODUCT = product.related_products.find(function(related) {
          return ((related.id + '') === (product.preorder_product + '')) &&
              related.tags.includes('preorder');
        });
        if (this.PREORDER_PRODUCT) {
          this.PREORDER_PRODUCT = this.buildModel(this.PREORDER_PRODUCT);
        }
      }
      if (product.related_product_thumbnails) {
        for (var i = 0; i < product.related_product_thumbnails.length; i++) {
          product.related_products[i].thumbnail_image = product.related_product_thumbnails[i];
        }
      }
      product.related_products = product.related_products.filter(
        function(product) {
          if (!product || product.tags.includes('preorder')) {
            return false;
          }
          var variants = product.variants;
          if (product.preorder_product && product.preorder_product.variants) {
            variants = variants.concat(product.preorder_product.variants);
          }
          if (!variants) {
            return false;
          }
          var availableVariants = variants.filter(function(variant) {
            return variant.available;
          });
          return availableVariants.length > 0;
        }
      );
    } else if (this.isAbbreviatedForm() && product.preorder_product) {
      this.PREORDER_PRODUCT = product.preorder_product;
      if (this.PREORDER_PRODUCT) {
        this.PREORDER_PRODUCT = this.buildModel(this.PREORDER_PRODUCT);
      }
    }
    product.swatches = [];
    for (var i = 0; i < product.options.length; i++) {
      var options = [];
      for (var j = 0; j < product.variants.length; j++) {
        pushIfNotFound(product.variants[j]['option' + (i + 1)], options);
      }
      var swatchLabel = swatchMap[product.options[i].toLowerCase()] || product.options[i];
      product.swatches.push({
        swatch_class: this.sanitizeSelectorComponent(product.options[i]),
        option_index: i,
        swatch: swatchLabel,
        options: options.map((function(option) {
          var valueClass = this.sanitizeSelectorComponent(option);
          var label = valueLabelMap[valueClass] ? valueLabelMap[valueClass] : option;
          var accessibilityLabel = accessibilityLabelMap[valueClass] ? accessibilityLabelMap[valueClass] : label;
          return {
            value_class: valueClass,
            value: option,
            label: label,
            accessibility_label: accessibilityLabel,
            value_description: valueDescriptionMap[valueClass] ?
              valueDescriptionMap[valueClass] : undefined
          };
        }).bind(this))
      });
    }
    var expandedSortOrder = {'size': 1, 'length-inseam': 2,  'waist': 3, 'length': 4,'liner': 5};
    var abbreviatedSortOrder = {'waist': 1, 'length': 2, 'size': 3, 'length-inseam': 4, 'liner': 5};
    var swatchDisplayOrder = this.isAbbreviatedForm() ? abbreviatedSortOrder : expandedSortOrder;
    product.swatches.sort(function(s1, s2) {
      if (!swatchDisplayOrder[s1.swatch_class]) {
        return 1;
      }
      if (!swatchDisplayOrder[s2.swatch_class]) {
        return -1;
      }
      return swatchDisplayOrder[s1.swatch_class] - swatchDisplayOrder[s2.swatch_class];
    });
    product.possibleOptions = [];
    product.variants.forEach(function(variation) {
      for (var i = 0; i < product.options.length; i++) {
        if (!product.possibleOptions[i]) {
          product.possibleOptions[i] = [];
        }
        if (variation['option' + (i + 1)]) {
          pushIfNotFound(
            variation['option' + (i + 1)],
            product.possibleOptions[i]
          );
        }
      }
    });
    return product;
  }).bind(this);

  var findSelectedVariant = (function(product, canBeUnavailable) {
    if (!product) {
      return undefined;
    }
    return product.variants.find((function(variant) {
      return (canBeUnavailable || variant.available) &&
          variant.option1 === this.SELECTED_PRODUCT.options['option-0'] &&
          (!variant.option2 ||
              variant.option2 === this.SELECTED_PRODUCT.options['option-1']) &&
          (!variant.option3 ||
              variant.option3 === this.SELECTED_PRODUCT.options['option-2']);
    }).bind(this));
  }).bind(this);

  this.addEvents = (function() {
    $('#add-to-cart').on('click', this.sideEffect(function(e) {
      if ((this.PRODUCT.type === 'Gift Card') ||
          (this.SELECTED_VARIANT && this.SELECTED_VARIANT.available)) {
        if ($('#preorder-popup').length) {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.closePopup();
        }
        this._ACTION_QUEUE.push((function() {
          Shopify.addItemFromForm(this.sel('form').get(), (function() {
            ajaxCart.load();
            this.logLearnq();
            RightDrawer.open();
            this.SUBMIT_CB && this.SUBMIT_CB();
          }).bind(this), console.log);
        }).bind(this));
      } else {
        // e.preventDefault();
        // e.stopImmediatePropagation();
      }
      var errors = {
        'waist': 'Select pants waist',
        'length': 'Select pants length',
        'liner': 'Select with or without liner',
        'size': 'Select size',
        'length-inseam': 'Select length'
      };
      this.ERROR_MESSAGES = {};
      Object.keys(errors).forEach((function(swatch) {
        this.ERROR_MESSAGES[swatch] =
            this.sel('.swatch.' + swatch + ' input:checked').length === 0 ||
            this.sel('.swatch.' + swatch + ' input:checked').is('.disabled') ?
            errors[swatch] : '';
      }).bind(this));
      return function(e) {
        var errorMessage = $('.sr.message-list li a:first').get(0);
        if (errorMessage) {
          errorMessage.focus();
          e.preventDefault();
          e.stopPropagation();
          var clickMessage = function(e) {
            e.preventDefault();
            if (e.keyCode && e.keyCode !== 13 && e.keyCode !== 32) {
              return false;
            }
            var input = $(e.currentTarget).data('input');
            if ($('input[name="' + input + '"]:enabled:first').get(0)) {
              $('input[name="' + input + '"]:enabled:first').trigger('focus');
            }
            return false;
          }
          setTimeout(function () {
            $('.sr.message-list li a').on('keyup', clickMessage);
          }, 50);
        }
      };
    }));
    $('#add-to-cart').on('click', function() {
      gtag && gtag('event', 'conversion', {'send_to': 'AW-963327266/fYsyCLDq6_sCEKLqrMsD'});
    });
    var swatchSelect = this.sideEffect(function(e) {
      var isKeyboard = e.target.tagName === 'INPUT';
      var swatch = $(e.target).closest('.swatch-element').find('input');
      if (swatch.is('.disabled') && this.isAbbreviatedForm()) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      this.SELECTED_PRODUCT.options[swatch.attr('name')] =
          (swatch.is(':checked') && !isKeyboard ? undefined : swatch.attr('value'));
      this.ERROR_MESSAGES[$(e.target).closest('.swatch').data('swatchClass')] = undefined;
      var preorderVariant = findSelectedVariant(this.PREORDER_PRODUCT);
      this.SELECTED_VARIANT = findSelectedVariant(this.PRODUCT, preorderVariant === undefined);
      var oldIsPreorder = this.IS_PREORDER;
      if (this.SELECTED_VARIANT) {
        this.IS_PREORDER = false;

      } else {
        this.SELECTED_VARIANT = preorderVariant;
        this.IS_PREORDER = !!this.SELECTED_VARIANT;
      }
      this._SWITCHED_IS_PREORDER = oldIsPreorder !== this.IS_PREORDER;
      if (!isKeyboard && swatch.is(':checked')) {
        e.preventDefault();
        e.stopPropagation();
        var sibling = swatch.next();
        swatch.remove();
        swatch.insertBefore(sibling);
      }
      if (this.SELECTED_VARIANT && this.isAbbreviatedForm()) {
        if (this.IS_PREORDER) {
          var form = new ProductForm(
            Templates.getTemplate('PopUpForm'),
            product,
            '#preorder-popup',
            submitCb
          );
          form.SELECTED_VARIANT = this.SELECTED_VARIANT;
          form.IS_PREORDER = this.IS_PREORDER;
          form.render();
          $('#preorder-popup').addClass('preorder-popup-active');
          $('#preorder-popup .popup-close-button, #preorder-popup .popup-mask').click((function() {
            this.closePopup();
          }).bind(this));
          $(document).keyup((function(e) {
            if (e.keyCode === 27) {
              this.closePopup();
            }
          }).bind(this));

        } else if (!this.SELECTED_VARIANT.available) {
          new NotifyPopUpForm(
            Templates.getTemplate('NotifyPopUpForm'),
            this.SELECTED_VARIANT
          ).render();
        } else {
          this._ACTION_QUEUE.push((function() {
            Shopify.addItemFromForm(this.sel('form').get(), (function() {
              ajaxCart.load();
              this.logLearnq();
              RightDrawer.open();
              this.SUBMIT_CB && this.SUBMIT_CB();
            }).bind(this), console.log);
          }).bind(this));
        }
      }
      return (function() {
        if (isKeyboard) {
          for (var i = 0; i < this.PRODUCT.swatches.length; i++) {
            if (this.SELECTED_PRODUCT.options['option-' + this.PRODUCT.swatches[i].option_index] === undefined) {
              var toFocus = $('.swatch.' + this.PRODUCT.swatches[i].swatch_class + ' input').first();
              setTimeout(function() {
                toFocus.trigger('focus');
              }, 500);
              return true;
            }
          }
          $('#add-to-cart').trigger('focus');
        }
        return false;
      }).bind(this);
    });
    this.sel('.swatch label, .swatch input').click(swatchSelect);

    $('.thumbnails a').click(this.sideEffect(function(e) {
      var clicked = $(e.target).closest('a');
      $('.zoomImg').attr('src', clicked.attr('href'));
      if ($(window).width() >= 767) {
        if (this.FEATURED_IMAGE.index != clicked.data('index')) {
          this.FEATURED_IMAGE = {
            index: clicked.data('index'),
            href: clicked.attr('href'),
            src: clicked.attr('href'),
            media_type: clicked.data('type')
          };
        }
        e.stopPropagation();
        return false;
      }
    }));
    $('.product-images a').click(
      function() {
        $.fancybox.open($('.fancybox'), {
          padding: 0,
          nextEffect: 'fade',
          prevEffect: 'fade',
          index: $(this).data('index')
        });
        return false;
      });
    if (this.PRODUCT.media && this.PRODUCT.media.length >= 1) {
      $('#mobile-product-images').slick({
        dots: this.PRODUCT.media.length > 1,
        arrows: false,
        initialSlide: this.FEATURED_IMAGE.index
      });
      $('#mobile-product-images').on('afterChange', (function(e, slick, currentSlide) {
        this.FEATURED_IMAGE.index = currentSlide;
      }).bind(this));
      $('#mobile-product-images a').on('click', function(e) {
        $('#mobile-product-images').slick('slickNext');
        e.preventDefault();
      });
      if (this.PRODUCT.media.length > 1) {
        $('.mobile-product-image-thumbnails a').on('click', function() {
          $('#mobile-product-images').slick('slickGoTo', $(this).index());
          return false;
        });
      }
    }
    $('.swatch-options input').keyup((function(e) {
      if (e.keyCode === 32) {
        setTimeout((function () {
          var inps = $('.swatch-options input:enabled').toArray().filter(
            (function(inp) {
              return !this.SELECTED_PRODUCT.options[inp.name];
            }).bind(this)
          );
          if (inps && inps.length > 0) {
            inps[0].trigger('focus');
          } else if ($('#add-to-cart').get(0)) {
            $('#add-to-cart').trigger('focus');
          }
        }).bind(this), 50);
      }
    }).bind(this));
    $('.swatch-options input').keydown((function(e) {
      if (e.keyCode === 37 || e.keyCode === 39) {
        setTimeout(function() {
          $('[name="' + e.target.name + '"]:checked').get(0).trigger('focus');
        }, 50);
      }
    }).bind(this));
    $('.swatch-selector-pants').click((function(e) {
      e.preventDefault();
      var productHandle = $(e.target).closest('a').attr('href').substring('/product/'.length + 1);
      $('.product-page').addClass('product-loading');
      switchProducts(productHandle, false, {});
      return false;
    }).bind(this));
    $('.product-description .product-reviews-avg-rating-count').click(function() {
      $([document.documentElement, document.body]).animate({
          scrollTop: $('.product-reviews-container').offset().top - 80
      }, 1000);
    });
    var dtToggle = this.sideEffect(function(i) {
      const index = this.EXPANDED_DDS.indexOf(i);
      if (index > -1) {
        this.EXPANDED_DDS.splice(index, 1);
      } else {
        this.EXPANDED_DDS.push(i);
      }
    }.bind(this));
    $('.product-dl dt').each(function(i) {
      $(this).click(function() {
        dtToggle(i);
      });
    });
    if (this.SELECTED_VARIANT && !this.SELECTED_VARIANT.available) {
      var klaviyo = window.klaviyo || [];
      klaviyo.init({
        account: 'HtwjM2',
        platform: 'shopify',
        display_on_policy_continue: true
      });
      klaviyo.enable('backinstock', { 
        modal: {
          headline: this.PRODUCT.title,
          body_content: 'Register to receive a notification when this item comes back in stock.',
          email_field_label: 'Email',
          button_label: 'NOTIFY ME WHEN AVAILABLE',
          subscription_success_label: 'You\'re in! We\'ll let you know when it\'s back.',
          footer_content: '',
          additional_styles:
            '@import url(\'https:////fonts.googleapis.com/css?family=.|PT+Sans+Narrow:light,normal,bold|Open+Sans:light,normal,bold|Open+Sans:light,normal,bold|Open+Sans:light,normal,bold|Source+Sans+Pro:light,normal,bold,black|Poppins:light,normal,bold\');' +
            '#klaviyo-bis-modal { width: 90%; margin: -164px auto 0 auto; position: relative; top: 50%; box-shadow: rgba(0, 0, 0, .23) 0px 10px 30px 0px; }' +
            '#container { margin-top: 0 !important; }'
            ,
          font_family: '"Source Sans Pro", "Open Sans", sans-serif;',
          drop_background_color: '#000',
          background_color: '#fff',
          text_color: '#222',
          button_text_color: '#fff',
          button_background_color: '#1b213e',
          close_button_color: '#ccc',
          error_background_color: '#fcd6d7',
          error_text_color: '#C72E2F',
          success_background_color: '#d3efcd',
          success_text_color: '#1B9500'
        }
      });
    }
  }).bind(this);

  var isClickable = (function(product, optionIndex, optionValue) {
    return (this.SELECTED_PRODUCT.options['option-' + optionIndex] === optionValue) ||
        product.variants.some(
          (function(variant) {
            return (variant['option' + (optionIndex + 1)] === optionValue) &&
              product.options.every(
                (function(option, index) {
                  if (index !== optionIndex && this.SELECTED_PRODUCT.options['option-' + index]) {
                    return this.SELECTED_PRODUCT.options['option-' + index] === variant['option' + (index + 1)];

                  } else {
                    return true;
                  }
                }).bind(this));
          }).bind(this));
  }).bind(this);

  this.updateModel = (function() {
    for (var i = 0; i < this.PRODUCT.options.length; i++) {
      for (var j = 0; j < this.PRODUCT.possibleOptions[i].length; j++) {
        var clickable = isClickable(this.PRODUCT, i, this.PRODUCT.possibleOptions[i][j]) ||
            (this.PREORDER_PRODUCT && isClickable(this.PREORDER_PRODUCT, i, this.PRODUCT.possibleOptions[i][j]));
        var clickableSwatch = this.PRODUCT.swatches.find(
            function(swatch) {
              return swatch.option_index === i;
            })
          .options.find(
            (function(option) {
              return option.value === this.PRODUCT.possibleOptions[i][j];
            }).bind(this));
        if (clickableSwatch) {
          clickableSwatch.clickable = clickable;
        }
      }
    }
    this.sel('.swatch :radio:checked').each(function() {
      if (!$(this).is('.disabled')) {
        $(this).closest('.swatch').find('.swatch-error').text('');
      }
    });
  }).bind(this);

  this.sideEffect = (function(fn) {
    return (function(e) {
      var eax = fn.bind(this)(e);
      this.render();
      while (typeof eax === 'function') {
        eax = eax(e);
      }
      return eax;
    }).bind(this)
  }).bind(this);

  this.render = (function() {
    this.updateModel();
    var productToRender;
    if (!this.IS_PREORDER) {
      productToRender = $.extend({}, this.PRODUCT);

    } else {
      productToRender = $.extend({}, this.PRODUCT, {
        title: this.PREORDER_PRODUCT.title,
        images: $.merge([this.PREORDER_PRODUCT.media[0]], this.PRODUCT.media),
        featured_image: this.PREORDER_PRODUCT.images[0],
        variants: this.PREORDER_PRODUCT.variants
      });
    }
    if (this._SWITCHED_IS_PREORDER) {
      if (this.IS_PREORDER) {
        this.FEATURED_IMAGE = {
          index: 0,
          href: productToRender.featured_image,
          src: productToRender.featured_image,
          media_type: 'image'
        };
      } else {
        var featuredIndex = Math.max(0, this.FEATURED_IMAGE.index - 1);
        var featuredMedia = productToRender.media[featuredIndex];
        var featuredSrc = featuredMedia.media_type === 'image' ?
            featuredMedia.src : featuredMedia.sources[1].url;
        this.FEATURED_IMAGE = {
          index: featuredIndex,
          href: featuredSrc,
          src: featuredSrc,
          media_type: featuredMedia.media_type
        };
      }
    }
    this._SWITCHED_IS_PREORDER = false;
    var oldReviewsSummary = $('.product-reviews-avg-rating').html();
    var rendered = this._TEMPLATE({
      product: productToRender,
      is_preorder: this.IS_PREORDER,
      selected_product: this.SELECTED_PRODUCT,
      selected_variant: this.SELECTED_VARIANT,
      featured_image: this.FEATURED_IMAGE,
      error_messages: this.ERROR_MESSAGES,
      expanded_dds: this.EXPANDED_DDS,
      is_expanded: true,
    });
    this.sel().html(rendered);
    $('.product-reviews-avg-rating').html(oldReviewsSummary);
    this.addEvents();
    initEffects && initEffects(this.PRODUCT);
    try {
      ajaxCart.init({
        formSelector: selectors.productForm,
        cartContainer: selectors.cartContainer,
        addToCartSelector: selectors.addToCart
      });
      Drawers && new Drawers('CartDrawer', 'right', {
        'onDrawerOpen': ajaxCart.load
      });
    } catch (e) {

    }
    $('.size-guide-link').leanModal({closeButton: '.close'});
    if (this._ACTION_QUEUE.length) {
      this._ACTION_QUEUE.forEach(function(action) {
        action();
      });
      this._ACTION_QUEUE = [];
    }
  }).bind(this);

  this._TEMPLATE = template;
  this._ACTION_QUEUE = [];
  this._SWITCHED_IS_PREORDER = false;
  this.IS_PREORDER = false;
  this.PRODUCT = this.buildModel(product);
  this.FORM_SELECTOR = formSelector || '';
  this.SELECTED_VARIANT = undefined;
  this.SELECTED_PRODUCT = { options: {} };
  this.FEATURED_IMAGE = {
    index: 0,
    href: this.PRODUCT.featured_image,
    src: this.PRODUCT.featured_image
  };
  this.EXPANDED_DDS = [];
  this.ERROR_MESSAGES = {};
  this.SUBMIT_CB = submitCb;
};

var ProductReviews = function(template, product, selector, onLoadCb) {
  this.render = (function() {
    var rendered = template({
      product: product,
    });
    $(selector).html(rendered);
    if (onLoadCb) {
      onLoadCb();
    }
  }).bind(this);
};

var ProductStory = function(template, product, selector, onLoadCb) {
  this.render = (function() {
    var rendered = template({
      product: product,
    });
    $(selector).html(rendered);
    if (onLoadCb) {
      onLoadCb();
    }
  }).bind(this);
};

var ProductReviewsSummary = function(template, product, selector) {
  this.render = (function() {
    var rendered = template({
      product: product,
    });
    $(selector).html(rendered);
    $('.product-description .product-reviews-avg-rating-count').click(function() {
      $([document.documentElement, document.body]).animate({
          scrollTop: $('.product-reviews-container').offset().top - 80
      }, 1000);
    });
  }).bind(this);
};

var NotifyPopUpForm = function(template, product) {
  this.render = (function(completeMsg) {
    var rendered = template({
      product: product,
      isComplete: completeMsg === true ? true : false,
      errorMessage: typeof completeMsg === 'string' ? completeMsg : undefined
    });
    $('#preorder-popup').html(rendered);
    $('#preorder-popup form').on('submit', this.submit);
    $('#preorder-popup button[type="submit"]').on('click', this.submit);
    $('#preorder-popup .klaviyo-bis-close, #preorder-popup .popup-mask').on('click', this.closePopup);
    $(document).on('keyup', this.closePopup);

    $('#preorder-popup').addClass('preorder-popup-active');
  }).bind(this);
  this.closePopup = function(e) {
    if (e && (e.type !== 'keyup' || e.keyCode === 27)) {
      $('#preorder-popup').removeClass('preorder-popup-active');
      $('#preorder-popup').html('');
    }
    return false;
  }
  this.submit = (function() {
    var email = $('#preorder-popup input[name=email]').val();
    if (email && email.match(/^\S+@\S+\.\S+$/g)) {
      window.CORS_POST('https://a.klaviyo.com/api/v1/catalog/subscribe', {
        a: 'HtwjM2',
        email: email,
        variant: this.PRODUCT.id,
        platform: 'shopify'
      });
      this.render(true);
    } else {
      this.render('Please enter a valid email address');
    }
    return false;
  }).bind(this);

  this.PRODUCT = product;
};